<router-outlet></router-outlet>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#ffffff" type="ball-beat"><p class="colorWhite" > Fetching Data... </p></ngx-spinner>
<p-toast key="notification" position="top-right"></p-toast>

